import { Injectable, Inject } from '@angular/core';
import { CoreLibConfig } from '../core.module';

declare let gtag: (...args: any) => void;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(@Inject('CONFIG') private config: CoreLibConfig) {}

  sendEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel?: string,
    eventValue?: number,
  ): void {
    try {
      gtag('send', 'event', {
        eventCategory,
        eventLabel,
        eventAction,
        eventValue,
      });
    } catch {
      console.log('gtag send failed');
    }
  }

  pageView(url: string): void {
    try {
      gtag('config', this.config.gtagId, {
        page_path: url,
      });
    } catch {
      console.log('gtag config failed');
    }
  }
}
